import { notFound } from '@tanstack/react-router';
import type { PermissionCode } from '@/constants/permissions';
import { useAuthStore } from '@/store/auth.store';

export function requirePermission(code: PermissionCode): void {
  requireAnyPermission(code);
}

export function requireAnyPermission(...codes: PermissionCode[]): void {
  const { permissions, isAdmin, arePermissionsLoaded } = useAuthStore.getState();

  if (!arePermissionsLoaded || isAdmin || codes.some((code) => permissions.includes(code))) return;

  throw notFound();
}
